<template>
  <div class="footer">
    <div class="footer_up">
      <div class="container hidden-xs">
        <div class="content">
          <div class="content_left">
            <img
              class="img-responsive"
              src="@/assets/images/footer_logo.png"
              alt
            />
          </div>
          <div class="content_nav_list">
            <ul class="list">
              <li @click="jump('about')">关于我们</li>
              <li>
                <a href="#intro" @click="jump('about')">公司简介</a>
              </li>
              <li>
                <a href="#development" @click="jump('about')">发展历程</a>
              </li>
              <li>
                <a href="#product" @click="jump('about')">产品介绍</a>
              </li>
              <li>
                <a href="#map" @click="jump('about')">联系我们</a>
              </li>
            </ul>
          </div>
          <div class="content_nav_list">
            <ul class="list">
              <li>媒体报道</li>
              <li>
                <a @click="jump('media')" href="#news">新闻动态</a>
              </li>
              <li>
                <a @click="jump('media')" href="#history">历史报道</a>
              </li>
            </ul>
          </div>
          <div class="content_nav_list">
            <ul class="list">
              <li>加入我们</li>
              <li>
                <a @click="jump('joinus')" href="#culture">企业文化</a>
              </li>
              <li>
                <a @click="jump('joinus')" href="#join">招聘职位</a>
              </li>
            </ul>
          </div>
          <div class="content_right">
            <div class="d-flex btn_group">
              <img
                class="gzh_qrcode"
                src="@/assets/images/pc_home_img_account.png"
                alt
              />
              <img
                class="gzh_qrcode"
                src="@/assets/images/pc_home_img_app.png"
                alt
              />
              <div class>
                <button class="btn" @click="jumpAppStore">
                  <span class="icon iconfont iconIconmetro-apple"></span>
                  App Store
                </button>
                <button class="btn" @click="jumpAndroid">
                  <span class="icon iconfont iconIconawesome-android2"></span>
                  Android下载
                </button>
                <button class="btn" @click="jumpHarmonyOS">
                  <span class="icon iconfont iconhome_icon_harmonyos"></span>
                  鸿蒙版下载
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 手机端布局 -->
      <div class="visible-xs">
        <ul class="mobile-title">
          <li @click="jump('home')">首页</li>
          <li @click="jump('about')">关于我们</li>
          <li @click="jump('media')">媒体报道</li>
          <li @click="jump('joinus')">加入我们</li>
        </ul>
        <div class="d-flex btn_group">
          <div class="qrcode_box">
            <img src="@/assets/images/home_img_account@3x.png" alt />
            <span>掌上公交公众号</span>
          </div>
          <div class="qrcode_box">
            <img src="@/assets/images/home_img_app@3x.png" alt />
            <span>掌上公交APP二维码</span>
          </div>
          <div class="btn_box">
            <button class="btn" @click="jumpAppStore">
              <span class="icon iconfont iconIconmetro-apple"></span>
              App Store
            </button>
            <button class="btn" @click="jumpAndroid">
              <span class="icon iconfont iconIconawesome-android2"></span>
              Android下载
            </button>
            <button class="btn" @click="jumpHarmonyOS">
              <span class="icon iconfont iconhome_icon_harmonyos"></span>
              鸿蒙版下载
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="footer_down">
      <div class="hidden-xs">
        <div class="d-flex" style="align-items: center">
          <a href="http://beian.miit.gov.cn" target="_blank"
            >© 2009-2020 搜谷科技 闽 ICP备15022903号-1</a
          >
          <span class="icon-group">
            <span
              id="tooltip"
              class="icon iconfont iconweixin"
              data-toggle="tooltip"
              data-trigger="hover"
              data-placement="top"
              :data-title="imgUrl"
              data-html="true"
            ></span>
            <a href="https://weibo.com/zhangshanggongjiao" target="_blank">
              <span class="icon iconfont iconweibo"></span>
            </a>
          </span>
        </div>
      </div>

      <!-- 手机端布局 -->
      <div class="visible-xs">
        <div class="d-flex mobile-logo">
          <img src="@/assets/images/footer_logo.png" alt />
          <span class="icon-group">
            <span
              id="tooltip-mobile"
              class="icon iconfont iconweixin"
              data-toggle="tooltip-mobile"
              data-trigger="click"
              data-placement="top"
              :data-title="imgUrl"
              data-html="true"
            ></span>
            <a href="https://weibo.com/zhangshanggongjiao" target="_blank">
              <span class="icon iconfont iconweibo"></span>
            </a>
          </span>
        </div>
        <div class="icpNum"></div>
      </div>
    </div>
    <go-to-top></go-to-top>
    <share-modal v-show="isBrowser" ref="shareModal"></share-modal>
  </div>
</template>

<script>
import GoToTop from "components/operate/gototop";
import ShareModal from "components/sharemodal/sharemodal";

export default {
  data() {
    return {
      curConfig: {},
      imgUrl: `<div class='pic-popover'><img style="width:120px;height:145px;" src=${require("../../assets/images/gzh_qrcode.png")}></img></div>`,
      isBrowser: false
    };
  },
  components: {
    GoToTop,
    ShareModal
  },
  methods: {
    jump(url) {
      this.$router.push({
        path: "/" + url
      });
      // this.$parent.scrollIntoView(e);
    },
    jumpAppStore() {
      if (this.curConfig.isQQ) {
        this.isBrowser = true;
        this.$refs.shareModal.toogleShow();
        // window.open(
        //   `https://sj.qq.com/myapp/detail.htm?apkName=com.mygolbs.mybus`
        // );
      } else {
        if(this.curConfig.isPC || !this.curConfig.isWeiXin) {
          window.location.href = `https://itunes.apple.com/cn/app/%E6%8E%8C%E4%B8%8A%E5%85%AC%E4%BA%A4-%E7%B2%BE%E5%87%86%E5%AE%9E%E6%97%B6%E5%85%AC%E4%BA%A4%E5%9C%B0%E9%93%81%E6%9F%A5%E8%AF%A2/id461317017`;
        } else {
          window.open(`https://a.app.qq.com/o/simple.jsp?pkgname=com.mygolbs.mybus`);
        }
        // window.open(
        //   `https://apps.apple.com/cn/app/%E6%8E%8C%E4%B8%8A%E5%85%AC%E4%BA%A4-%E7%B2%BE%E5%87%86%E5%AE%9E%E6%97%B6%E5%85%AC%E4%BA%A4%E5%9C%B0%E9%93%81%E6%9F%A5%E8%AF%A2/id461317017`
        // );
      }
    },
    jumpAndroid() {
      if (this.curConfig.isWeiXin || this.curConfig.isQQ) {
        this.isBrowser = true;
        this.$refs.shareModal.toogleShow();
      } else {
        if(this.curConfig.isPC) {
          window.open(`https://m.mygolbs.com/dl/MyBus.apk`);
        } else {
          window.open("market://details?id=com.mygolbs.mybus");
        }
        // window.open(`https://link.vvstc.com/index.html?id=com.mygolbs.mybus`);
      }
      // else if (this.curConfig.isHUAWEI) {
      //   window.open(
      //     `https://appgallery.cloud.huawei.com/uowap/index.html#/detailApp/C10457429`
      //   );
      // } else if (this.curConfig.isVIVO) {
      //   window.open(`http://appdetailh5.vivo.com.cn/detail/54763?source=7`);
      // } else if (this.curConfig.isXIAOMI) {
      //   window.open(`http://app.xiaomi.com/detail/33487`);
      // } else if (this.curConfig.isMEIZU) {
      //   window.open(
      //     `http://app.meizu.com/apps/public/detail?package_name=com.mygolbs.mybus`
      //   );
      // } else if (this.curConfig.isHONOR) {
      //   window.open(
      //     "https://appmarket-h5.cloud.honor.com/h5/share/latest/index.html?shareId=1912779738551418880&shareTo=copyLink"
      //   );
      // }
    },
    jumpHarmonyOS() {
      if (this.curConfig.isWeiXin || this.curConfig.isQQ) {
        this.isBrowser = true;
        this.$refs.shareModal.toogleShow();
      } else
        window.open(
          `https://appgallery.huawei.com/app/detail?id=com.mygolbs.mybus.hm`
        );
    }
  },
  mounted() {
    // console.log($('[data-toggle="tooltip"]'));
    this.curConfig = this.$browser();
    $("#tooltip").tooltip({
      title: () => {
        return this.imgUrl;
      }
    });
    $("#tooltip-mobile").tooltip({
      trigger: "click",
      title: () => {
        return this.imgUrl;
      }
    });
    // $('[data-toggle="tooltip"]').tooltip();
  }
};
</script>

<style lang="less" scoped>
@import "./footer.less";
</style>

<style lang="less">
@import "./footer.copy.css";
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue